/**
 * `dashboard` namespace — English canonical source.
 *
 * Owned by the Dashboard team: the `/` overview route plus the presentational
 * panel states shared by both the dashboard and the portfolio drill-down
 * (`features/dashboard/panels.tsx` — error/empty/gate chrome). Panel *titles*
 * live here because they are reused across surfaces; portfolio-only copy lives in
 * the `portfolio` namespace. Keys are dot-free camelCase; `ko/dashboard.ts`
 * mirrors this shape (a missing key is a compile error). Shared verbs
 * (retry/close/loading) are NOT re-declared here — call sites use `common.*`.
 */
export const dashboard = {
  // ── overview route chrome ──
  overviewEyebrow: "Overview",
  description:
    "Portfolio value, profit-vs-deposit decomposition, allocation, and strategy performance.",

  // ── panel titles (shared with the portfolio route) ──
  panelPortfolioValue: "Portfolio value",
  panelDecomposition: "Profit vs. deposits",
  panelAllocation: "Allocation",
  panelStrategyPnl: "Strategy P&L",

  // ── panel states ──
  panelErrorTitle: "Couldn't load this",
  strategyPnlLoadError: "Failed to load strategy performance.",
} as const;

export type DashboardKey = keyof typeof dashboard;
